var React = require('react');

function HeartInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"3","d":"M33,8.5c-3.5,0-6.471,2-9,6 c-2.529-4-5.5-6-9-6c-5.247,0-9.5,4.253-9.5,9.5c0,6.5,11,15,18.5,22.5c7.5-7.5,18.5-16,18.5-22.5C42.5,12.753,38.247,8.5,33,8.5z","fillRule":"evenodd"}));
}

HeartInline.defaultProps = {"fill":"currentColor","viewBox":"0 0 48 48"};

module.exports = HeartInline;

HeartInline.default = HeartInline;
